import React from "react";
import { Layout } from "antd";

const CustomFooter = ({ openPolicyModal }) => {
  const { Footer } = Layout;

  return (
    <Footer className="footer-wrapper" style={{ display: "flex", justifyContent: "space-between" }}>
      <button onClick={openPolicyModal} style={{ all: "unset", textDecoration: "underline" }}>
        이용약관
      </button>
      <span style={{ color: "#7ae290" }}>Powered by ⓒ H2O KOREA</span>
    </Footer>
  );
};

export default CustomFooter;
